import logo from './logo.svg';
import './App.css';
import { Routing } from './routing';
import { QueryCache, QueryClient, QueryClientProvider } from 'react-query';
import toast, { Toaster } from 'react-hot-toast';

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error) => {
      let message = 'Terjadi kesalahan.';

      if (typeof error === 'string') {
        message = error;
      } else if (error?.response?.data) {
        const data = error.response.data;
        const detail = error.message || data._server_messages;
        const code = data.exc_type || data.code;

        if (detail && code) {
          message = `${detail}\ ${code}`;
        } else if (detail) {
          message = detail;
        } else if (code) {
          message = `${code}`;
        }
      } else if (error?.message) {
        message = error.message;
      }

      toast.error(message);
      console.error(error);
    },
  }),
  defaultOptions: {
    queries: {
      retry: false,
      useErrorBoundary: false,
    },
  }
});


function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Toaster/>
      <Routing/>
    </QueryClientProvider>
  );
}

export default App;
